import { v4 as uuid } from 'uuid';
import { Grid } from '@mui/material';
import useResponsive from '../../../hooks/UseResponsive';
import BlockProps from '../../../models/BlockProps';
import BlockSNSData from './BlockSNSData';
import CroppedImage from '../../CroppedImage';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import useGetBackground from '../../../hooks/UseGetBackground';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';

export const generateIconItemId = (id: string, key: number) => `${id}-sns-icon-block-${key}`;

const BlockSNSPreview = (props: BlockProps) => {
  const {
    data,
    previewMode,
  } = props;

  const blockData = data.data as BlockSNSData;
  const { icons } = blockData;

  const iconsItemIds = icons.map((icon, key) => generateIconItemId(data.id, key));

  useResponsive({
    items: iconsItemIds.map((iconsItemId) => ({
      wrapperId: `sns-icon-block-container-${data.id}`,
      targetId: iconsItemId,
      queries: [
        { size: 0, className: 'col-4' },
        { size: 500, className: 'col-sm-2' },
      ],
    })),
  });

  const elementUuid = uuid();
  useParallaxScript(blockData.url?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <div
      id={elementUuid}
      className=""
      style={{
        overflow: 'hidden',
        ...useGetBackground(blockData.url?.solidColor, blockData.url?.value, blockData.url?.settings?.scale, blockData.url?.settings?.scaleBool),
        backgroundPosition: 'center 0px',
      }}
    >
      <div className="p-bgimg">
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="block-content-wrapper"
        >
          <div className="p-wrapper p-wrapper-sm">
            <div className="p-inner">
              {blockData.title && (
                <div className="row align-items-center">
                  <div className="col-xs-12">
                    <div className="p-header text-center mb-4">
                      <div>
                        <h2>
                          <strong translate="no" className="notranslate" dangerouslySetInnerHTML={{ __html: blockData.title.value }} />
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row align-items-center">
                {blockData.leftPic && (
                  <div className={previewMode === 'pc' ? 'col-xs-12 col-sm-6' : ''}>
                    <div className="p-body">
                      <div className="p-img p-img-contain mb-4">
                        <CroppedImage image={blockData.leftPic} settings={blockData.leftPic?.settings} />
                      </div>
                    </div>
                  </div>
                )}
                <div className={previewMode === 'pc' ? 'col-xs-12 col-sm-6' : ''}>
                  <div className="p-body">
                    {blockData.rightSubTitle && (
                      <div className="mb-4 text-center">
                        <div>
                          <h3>
                            <strong
                              translate="no"
                              className="notranslate"
                              style={{ fontSize: '20px' }}
                              dangerouslySetInnerHTML={{ __html: blockData.rightSubTitle.value }}
                            />
                          </h3>
                        </div>
                      </div>
                    )}
                    {blockData.rightSubTitle2 && (
                      <div className="mb-4 text-center">
                        <div>
                          <h3>
                            <strong
                              translate="no"
                              className="notranslate"
                              style={{ fontSize: '20px' }}
                              dangerouslySetInnerHTML={{ __html: blockData.rightSubTitle2.value }}
                            />
                          </h3>
                        </div>
                      </div>
                    )}
                    {blockData.description && (
                      <div className="mb-4" style={{ wordWrap: 'break-word' }}>
                        <div translate="no" className="notranslate" dangerouslySetInnerHTML={{ __html: blockData.description.value }} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div id={`sns-icon-block-container-${data.id}`} className={`row align-items-stretch row-gap-4 justify-content-${blockData.iconsAlignment}`}>
                {icons && icons.map((icon, key) => (
                  <div id={generateIconItemId(data.id, key)} key={generateIconItemId(data.id, key)} className="sns-icon-item">
                    <div className="p-parts">
                      <div className="p-parts-item">
                        <div>
                          <div className="p-img">
                            <a target={icon.link?.linkData?.openType} href={icon.link?.linkData?.url}>
                              <CroppedImage image={icon.pic || BlockComponentImage.make(icon.iconUrl)} settings={icon.pic?.settings || BlockComponentImage.make(icon.iconUrl).settings} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="p-parts-item">
                        <div>
                          <div className="ql-align-center">
                            <strong translate="no" className="notranslate" dangerouslySetInnerHTML={{ __html: icon.title }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default BlockSNSPreview;
